import styled from 'styled-components';
import Button from '@components/Button';
import colors from '@styles/colors';

export const Container = styled.div`
  padding: 10px;
  width: 100%;
`;

export const Title = styled.div`
  color: ${colors.primary};
  margin: 5px 0 10px 5px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const HeaderBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;

  span {
    font-size: 16px;
    font-weight: bold;
  }
`;

export const Box = styled.div`
  background: #f5f5f5;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #333;
  margin-top: 10px;

  p {
    margin-left: 5px;
  }
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  margin-left: 5px;

  & > :first-child {
    margin-top: 5px;
  }
`;

export const Input = styled.input`
  height: 38px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0 10px;

  &:focus {
    border: 2px solid ${colors.primary};
  }
`;

export const ApplyButton = styled(Button)`
  width: 150px;
`;

export const SectionTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${colors.primary};
  margin: 20px 0 10px 0;
  border-bottom: 1px solid ${colors.primary};
  padding-bottom: 5px;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0;
`;

export const TagList = styled.div`
  font-size: 12px;
  color: #666;
  background: #f9f9f9;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 10px;

  span {
    font-weight: bold;
    color: ${colors.primary};
    margin-right: 5px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const QuillWrapper = styled.div`
  margin-top: 15px;
  margin-bottom: 5px;
  .ql-container {
    min-height: 150px;
    background: #fff;
  }
`;
